import React from "react";
import {ButtonGroup, OverlayTrigger, Tooltip} from "react-bootstrap";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

const SZENARIEN = [
    {
        wert: "sicher",
        label: "Sicher",
        hilfe: "Nur von Cosmos bestätigte Mengen zählen als Zulauf. Beantwortet: Womit kann ich rechnen, wenn nichts mehr kommt?",
    },
    {
        wert: "erwartet",
        label: "Erwartet",
        hilfe: "Bestätigtes plus bestelltes, um die gemessene mittlere Verspätung nach hinten geschoben. Beantwortet: Was passiert voraussichtlich?",
    },
    {
        wert: "bestellt",
        label: "Bestellt",
        hilfe: "Alles zum Wunschtermin, so als würde Cosmos exakt wie gewünscht liefern. Beantwortet: Wie sähe es aus, wenn Cosmos liefert wie zugesagt?",
    },
];

/**
 * Szenario-Umschalter sicher/erwartet/bestellt (PLAN.md Abschnitt 4.3,
 * Unterscheidung „können, sind, haben“) - eigene Knopfgruppe statt eines
 * Auswahlfelds, jede Option mit eigenem Erklär-Tooltip. `hilfeTexte` kommt
 * vom Backend (Klartext je Szenario, "szenario_hilfe" der Lieferfähigkeit) -
 * mit lokalem Rückfall, falls das Feld einmal fehlt.
 */
export default function SzenarioSchalter({value, onChange, hilfeTexte}) {
    return (
        <div className="d-inline-flex align-items-center gap-2">
            <HeaderWithHelp help="Drei Blickwinkel auf dieselbe Reichweite: was gesichert ist, was voraussichtlich passiert, und wie es bei planmäßiger Lieferung aussähe.">
                <span className="small text-muted">Szenario</span>
            </HeaderWithHelp>
            <ButtonGroup size="sm">
                {SZENARIEN.map((s) => (
                    <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} key={s.wert} placement="top" overlay={<Tooltip id={`cosmos-szenario-${s.wert}`}>{hilfeTexte?.[s.wert] || s.hilfe}</Tooltip>}>
                        <button
                            type="button"
                            className={`btn btn-outline-secondary${value === s.wert ? " active" : ""}`}
                            aria-pressed={value === s.wert}
                            onClick={() => onChange(s.wert)}
                        >
                            {s.label}
                        </button>
                    </OverlayTrigger>
                ))}
            </ButtonGroup>
        </div>
    );
}
